import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/galaxy-of-moments/page.tsx");
